import React from "react";

import { string, object, func, node, shape } from "prop-types";

import { TextFieldGroup } from "../../../../common/index";

const PayrollForm = ({
  restrictedValuesAttemptedChange,
  bankName,
  accountNumber,
  sortCode,
  accountName,
  nationalInsuranceNo,
  validation,
  handleChange,
}) => (
  <div className="row justify-content-center mt-2">
    <div className="col-md-6">
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <div className="d-flex  align-items-baseline">
              <label htmlFor="nationalInsuranceNo">
                National Insurance Number
              </label>
            </div>
            <TextFieldGroup
              classes="register_field"
              value={nationalInsuranceNo}
              placeholder="e.g. QQ123456C"
              validationMessages={
                restrictedValuesAttemptedChange.nationalInsuranceNo ||
                validation.nationalInsuranceNo
              }
              onlyShowValidationAfterChange={
                !!restrictedValuesAttemptedChange.nationalInsuranceNo
              }
              onChange={(e) => {
                handleChange("nationalInsuranceNo", e.target.value.trim());
              }}
            />
          </div>
          <div className="form-group">
            <div className="d-flex  align-items-baseline">
              <label htmlFor="bankName">Name of bank</label>
            </div>
            <TextFieldGroup
              classes="register_field"
              value={bankName}
              validationMessages={restrictedValuesAttemptedChange.bankName}
              placeholder="e.g. HSBC"
              onChange={(e) => {
                handleChange("bankName", e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <div className="d-flex  align-items-baseline">
              <label htmlFor="accountNumber">Account Number</label>
            </div>
            <TextFieldGroup
              classes="register_field"
              value={accountNumber}
              validationMessages={
                restrictedValuesAttemptedChange.accountNumber ||
                validation.accountNumber
              }
              onlyShowValidationAfterChange={
                !!restrictedValuesAttemptedChange.accountNumber
              }
              placeholder="e.g. 12345678"
              onChange={(e) => {
                handleChange("accountNumber", e.target.value.trim());
              }}
            />
          </div>
          <div className="form-group">
            <div className="d-flex  align-items-baseline">
              <label htmlFor="sortCode">Sort Code</label>
            </div>
            <TextFieldGroup
              classes="register_field"
              value={sortCode}
              validationMessages={
                restrictedValuesAttemptedChange.sortCode || validation.sortCode
              }
              onlyShowValidationAfterChange={
                !!restrictedValuesAttemptedChange.sortCode
              }
              placeholder="e.g. 654321"
              onChange={(e) => {
                handleChange("sortCode", e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <div className="d-flex  align-items-baseline">
              <label htmlFor="accountName">Name on account</label>
            </div>
            <TextFieldGroup
              classes="register_field"
              validationMessages={restrictedValuesAttemptedChange.accountName}
              value={accountName}
              placeholder="e.g. Mr John Smith"
              onChange={(e) => {
                handleChange("accountName", e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

PayrollForm.propTypes = {
  bankName: string.isRequired,
  accountNumber: string.isRequired,
  sortCode: string.isRequired,
  accountName: string.isRequired,
  nationalInsuranceNo: string.isRequired,
  validation: object.isRequired,
  handleChange: func.isRequired,
  restrictedValuesAttemptedChange: shape({
    bankName: node,
    accountNumber: node,
    sortCode: node,
    accountName: node,
    nationalInsuranceNo: node,
  }).isRequired,
};

export default PayrollForm;
